import { formatPrice } from "@luce/core";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Box,
  Divider,
  Icon,
  ListItem,
  Typography,
} from "@luce/ui";

import { CreditAccountTransactionTypeEnum } from "../../../__generated__/graphql";
import { usePackageDetailContext } from "../package-detail-context";

export function PackageCredit() {
  const { packageDetail } = usePackageDetailContext();
  const { creditAccount } = packageDetail;

  if (!creditAccount) return null;

  const { balance, transactions } = creditAccount;

  return (
    <>
      <Divider />
      <Box className="gap-spacing-md p-spacing-lg flex flex-col">
        <Box className="gap-spacing-md flex flex-row items-center">
          <Icon name="Package" size={32} weight="fill" className="text-luce-brand-primary" />
          <Box className="flex flex-col">
            <Typography variant="body-md" color="neutral-foreground-intermediate">
              Package Balance
            </Typography>
            <Typography variant="label-md" color="neutral-foreground-default">
              {`S$${balance}`}
            </Typography>
          </Box>
        </Box>

        <Accordion type="single" collapsible>
          <AccordionItem value="transactions" showDivider={false}>
            <AccordionTrigger>Transaction History</AccordionTrigger>
            <AccordionContent>
              {transactions.map((transaction, index) => (
                <ListItem key={transaction.id} divider={index < transactions.length - 1}>
                  <ListItem.Content>
                    <ListItem.ContentTitle>{transaction.description}</ListItem.ContentTitle>
                  </ListItem.Content>
                  <ListItem.Trailing>
                    <Typography
                      variant="body-sm"
                      color={
                        transaction.transactionType === CreditAccountTransactionTypeEnum.Payment
                          ? "system-danger-default"
                          : "system-success-default"
                      }
                    >
                      {formatPrice(transaction.amount)}
                    </Typography>
                  </ListItem.Trailing>
                </ListItem>
              ))}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
}
